import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_compatible@1.0.2@@ant-design/compatible/es/form/index.js
// module id = 2101
// module chunks = 0